'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GroupedView = require('./GroupedView');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroupedView).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/GroupedView/index.js
// module id = 1200
// module chunks = 1